/** Which drawing basis a model was authored in. */
export type RouteBasis = 'orthogonal' | 'isometric'

/**
 * The single reader of `grid_type` in the app.
 *
 * PIPE-FLO's isometric is a 2D DRAWING CONVENTION, not a 3D projection — the iso
 * layout is already baked into the coordinates the converter emits. This field only
 * says which convention was used, so the router knows to leave that geometry alone.
 *
 * Anything other than an explicit 'isometric' is orthogonal. That is a defined
 * default, not a silent fallback: the C++ record itself defaults to ORTHOGONAL
 * (`grid_settings.h`, `grid_type_field() <= ORTHOGONAL`). It also means models
 * imported before the converter emitted grid_settings, and models authored in
 * Connect (which write a document_header carrying only `authorship`), keep exactly
 * today's behaviour.
 *
 * The `| undefined` on every level is load-bearing, not noise: exactOptionalPropertyTypes
 * makes `{a?: T}` and `{a?: T | undefined}` different types, and Zod's z.infer emits
 * the latter. Without them this compiles here and fails at every call site.
 */
export function getRouteBasis(
  system:
    | {
        document_header?:
          | { grid_settings?: { grid_type?: string | undefined } | undefined }
          | undefined
      }
    | null
    | undefined,
): RouteBasis {
  return system?.document_header?.grid_settings?.grid_type === 'isometric'
    ? 'isometric'
    : 'orthogonal'
}
